
Vue.filter('localizeAmount', function (amount, decimals) {
    // @todo nachkommastellen smarter machen -> bei 0,001 müssen auch 3 decimals dargestellt werden, sonst immer 2
    return parseFloat(amount).toLocaleString('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2});
});

Vue.filter('localizePercent', function (val) {
    return parseFloat(val / 100).toLocaleString('de-DE', {style: 'percent'});
});

Vue.filter('localizeNumber', function (num) {
    return num.toLocaleString('de-DE');
});

Vue.filter('humanReadableFilesize', function (size) {
    var i = Math.floor(Math.log(size) / Math.log(1024));
    return ((size / Math.pow(1024, i)).toFixed(2) * 1).toLocaleString('de-DE') + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
});

Vue.filter('localizeDate', function (val) {
    return val ? new Date(val).toLocaleDateString('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit'}) : '';
});

Vue.filter('localizeTime', function (val) {
    return val ? new Date(val).toLocaleTimeString('de-DE', {hour: '2-digit', minute: '2-digit'}) : '';
});

Vue.filter('localizeDateTime', function (val) {
    return val ? new Date(val).toLocaleDateString('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit'}) + ' ' + new Date(val).toLocaleTimeString('de-DE', {hour: '2-digit', minute: '2-digit'}) : '';
});

Vue.filter('autoLinks', function (val, escape = false) {
    if (escape) {
        val = val
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
    }

    const URLMatcher = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/igm;
    return val.replace(URLMatcher, match => `<a href="${match}" target=_blank rel=nofollow>${match}</a>`);
});

Vue.filter('truncateWords', function (str, max = 10) {

    if (str === null || typeof str === 'undefined') {
        return '';
    }

    const array = str.trim().split(' ');
    const ellipsis = array.length > max ? '...' : '';
    return array.slice(0, max).join(' ') + ellipsis;
});

Vue.filter('nl2br', function (str) {
    
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    
    var breakTag = '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
});

function generateRandomString(length)
{
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
}
